
import request from '@/util/http'
import qs from "qs";



// 获取体系tree
export function getHierarchyList (query) {
    return request({
        url: '/admin/hierarchy/page',
        method: 'get',
        params: query
    })
}




// 获取体系tree
export function getHierarchyTree (query) {
    return request({
        url: '/admin/hierarchy/tree',
        method: 'get',
        params: query
    })
}

// 添加体系
export function addHierarchy (query) {
    return request({
        url: '/admin/hierarchy',
        method: 'post',
        data: query
    })
}
// 删除体系
export function deleteHierarchy (query) {
    return request({
        url: '/admin/hierarchy/'+query,
        method: 'delete',
        // data: query
    })
}
// 批量删除体系
export function deleteBatch (query) {
    return request({
        url: '/admin/hierarchy/deleteMultiHies',
        method: 'post',
        data: qs.stringify(query)
})
}

// 更新体系
export function putHierarchy (obj) {
    return request({
        url: '/admin/hierarchy',
        method: 'put',
        data: obj
    })
}

// 获取诊改倒计时
export function setTime (query) {
    return request({
        url: '/admin/sysparams/cutdown',
        method: 'get',
        params: query
    })
}
export function updateDept (query) {
    return request({
        url: '/admin/hierarchy',
        method: 'put',
        data: query
    })
}

export function hiedUp (query) {
    return request({
        url: '/admin/hiedup/check/'+query,
        method: 'get',
        // params: query
    })
}

export function hiedUpList (query) {
    return request({
        url: '/admin/hiedup/page',
        method: 'get',
        params: query
    })
}

export function hiedUpDetail (query) {
    return request({
        url: '/admin/hiedup/'+query,
        method: 'get',
        // params: query
    })
}
export function deleteHiedUp (query) {
    return request({
        url: '/admin/hiedup/'+query,
        method: 'delete',
        // params: query
    })
}

export function saveHiedUp (query) {
    return request({
        url: '/admin/hiedup/',
        method: 'post',
        data: query
    })
}

export function downFile(id) {
    return request({
        url:`/admin/files/download/hierarchyfile/${id}`,
        method: 'get',
    })
}

export function uploadFile(name,path) {
    return request({
        url:`/admin/files/upload/hierarchyfile?originalFileName=${name}`,
        method: 'get',
    })
}


